(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomAssetTypeAttribute', CustomAssetTypeAttribute);

    CustomAssetTypeAttribute.$inject = ['$resource'];

    function CustomAssetTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-asset-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
